import { Autocomplete } from 'seagull';
import { Select } from 'seagull';
import { MenuItem } from 'seagull';
import styles from "../GlobalBillingHub.module.scss";
import { getAgreementOptions, getDefaultRelationshipId } from "../GlobalBillingHub.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GlobalBillingHubHeader = _ref => {
  let {
    agreements,
    clientOptions,
    selectedClient,
    changeUrlState,
    setAgreementOptions,
    agreementOptions,
    relationshipId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.filters,
    children: [/*#__PURE__*/_jsx(Autocomplete, {
      freeSolo: true,
      forcePopupIcon: true,
      className: styles.autocomplete,
      "data-testid": "gbh-client",
      options: clientOptions,
      value: selectedClient,
      getOptionLabel: option => option.text,
      textFieldProps: {
        label: 'Client',
        placeholder: 'Choose a client to bill'
      },
      onChange: (_, newOption) => {
        if (!newOption) {
          changeUrlState({
            clientId: '',
            relationshipId: '',
            selectedDate: ''
          });
          setAgreementOptions([]);
        } else if (typeof newOption !== 'string' && !Array.isArray(newOption)) {
          const newClientId = newOption.id;
          const newAgreementOptions = getAgreementOptions(agreements, newClientId);
          setAgreementOptions(newAgreementOptions);
          changeUrlState({
            clientId: newClientId,
            relationshipId: getDefaultRelationshipId(newAgreementOptions),
            selectedDate: ''
          });
        }
      }
    }), relationshipId && /*#__PURE__*/_jsx(Select, {
      width: 400,
      label: "Agreement",
      testid: "gbh-relationship",
      value: relationshipId,
      menuMaxHeight: 400,
      placeholder: "No Agreements to show",
      onChange: e => changeUrlState({
        relationshipId: e.target.value,
        selectedDate: ''
      }),
      children: agreementOptions.map((_ref2, idx) => {
        let {
          id,
          text
        } = _ref2;
        return /*#__PURE__*/_jsx(MenuItem, {
          value: id,
          "data-testid": "gbh-relationship-opt-".concat(idx),
          children: text
        }, id);
      })
    })]
  });
};